import * as types from './actionTypes'
import { loadPagination } from '../../utils/constants'
import { getMappedLoadsByHash } from './selectors'

export const initialState = {
  allMappedLoads: {},

  marketLoads: null,
  myLoads: null,
  reviewLoads: null,
  lockedLoads: null,
  closedLoads: null,
  inProgressLoads: null,

  hasMoreMarket: true,
  hasMoreMy: true,
  hasMoreReview: true,
  hasMoreLocked: true,
  hasMoreClosed: true,

  hasMoreNegotiation: true,
  hasMoreHired: true,
  hasMoreInTransit: true,
  hasMoreDelivered: true,
  hasMoreInProgress: true,

  pageNegotiation: 0,
  pageHired: 0,
  pageInTransit: 0,
  pageDelivered: 0,
  pageInProgress: 0,

  loadsQuantityInfo: null,
  loadsQuantityMarket: null,
  loadsQuantityReview: null,
  loadsQuantityMy: null,
  loadsQuantityLocked: null,
  loadsQuantityClosed: null,

  operationGroups: [],
  filters: null,

  amountNegotiation: 0,
  amountHired: 0,
  amountTransit: 0,
  amountDelivered: 0,
  amountInProgress: 0,

  viewAmountNegotiation: false,
  viewAmountHired: false,
  viewAmountTransit: false,
  viewAmountDelivered: false,
  viewAmountInProgress: false,

  loadingAmountNegotiation: false,
  loadingAmountHired: false,
  loadingAmountTransit: false,
  loadingAmountDelivered: false,
  loadingAmountInProgress: false,

  lastUpdateMarket: new Date().getTime(),
  lastUpdateHired: new Date().getTime(),
  lastUpdateDelivered: new Date().getTime(),
  lastUpdateInProgress: new Date().getTime(),
  lastUpdateTransit: new Date().getTime(),

  updatesAvailable: 0,

  listScroll: false,
}

const Loads = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_LOAD_BY_PARAMS:
      return {
        ...state,
        allMappedLoads: {
          ...state.allMappedLoads,
          ...getMappedLoadsByHash(payload),
          lastUpdate: new Date().getTime(),
        },
      }
    case types.INCREMENT_UPDATES:
      return { ...state, updatesAvailable: state.updatesAvailable + 1 }
    case types.CLEAR_ALL_LOADS:
      return {
        ...state,
        marketLoads: null,
        myLoads: null,
        reviewLoads: null,
        lockedLoads: null,
        closedLoads: null,
        inProgressLoads: null,

        hasMoreMarket: true,
        hasMoreMy: true,
        hasMoreReview: true,
        hasMoreLocked: true,
        hasMoreClosed: true,

        hasMoreNegotiation: true,
        hasMoreHired: true,
        hasMoreInTransit: true,
        hasMoreDelivered: true,
        hasMoreInProgress: true,

        pageNegotiation: 0,
        pageHired: 0,
        pageInTransit: 0,
        pageDelivered: 0,
        pageInProgress: 0,

        loadsQuantityInfo: null,
        loadsQuantityMarket: null,
        loadsQuantityReview: null,
        loadsQuantityMy: null,
        loadsQuantityLocked: null,
        loadsQuantityClosed: null,

        amountNegotiation: 0,
        amountHired: 0,
        amountTransit: 0,
        amountDelivered: 0,
        amountInProgress: 0,

        lastUpdateMarket: new Date().getTime(),
        lastUpdateHired: new Date().getTime(),
        lastUpdateDelivered: new Date().getTime(),
        lastUpdateInProgress: new Date().getTime(),
        lastUpdateTransit: new Date().getTime(),

        updatesAvailable: 0,

        listScroll: false,
      }

    case types.SET_UPDATES:
      return { ...state, updatesAvailable: payload }
    case types.SAVE_FILTERS_LOADS:
      return { ...state, filters: payload }
    case types.OPERATION_GROUPS_LOADS:
      return { ...state, operationGroups: payload }

    case types.CLEAR_MARKET_LOADS:
      return {
        ...state,
        marketLoads: [],
        hasMoreMarket: true,
        hasMoreNegotiation: true,
      }
    case types.CLEAR_REVIEW_LOADS:
      return { ...state, reviewLoads: [], hasMoreReview: true }
    case types.CLEAR_MY_LOADS:
      return { ...state, myLoads: [], hasMoreMy: true, pageHired: true }
    case types.CLEAR_LOCKED_LOADS:
      return {
        ...state,
        lockedLoads: [],
        hasMoreLocked: true,
        pageInTransit: true,
      }
    case types.CLEAR_CLOSED_LOADS:
      return {
        ...state,
        closedLoads: [],
        hasMoreClosed: true,
        pageDelivered: true,
      }
    case types.CLEAR_IN_PROGRESS_LOADS:
      return { ...state, inProgressLoads: [], hasMoreInProgress: true }

    case types.SET_LIST_SCROLL:
      return {
        ...state,
        listScroll: payload,
      }
    case types.FETCH_INFO_MARKET_LOADS:
      return { ...state, loadsQuantityMarket: payload }
    case types.FETCH_INFO_LOCKED_LOADS:
      return { ...state, loadsQuantityLocked: payload }
    case types.FETCH_INFO_MY_LOADS_LOADS:
      return { ...state, loadsQuantityMy: payload }
    case types.FETCH_INFO_REVIEW_LOADS:
      return { ...state, loadsQuantityReview: payload }
    case types.FETCH_INFO_CLOSED_LOADS:
      return { ...state, loadsQuantityClosed: payload }

    case types.PAGE_MARKET_LOADS:
      return { ...state, pageNegotiation: payload }
    case types.PAGE_HIRED_LOADS:
      return { ...state, pageHired: payload }
    case types.PAGE_IN_TRANSIT_LOADS:
      return { ...state, pageInTransit: payload }
    case types.PAGE_DELIVERED_LOADS:
      return { ...state, pageDelivered: payload }
    case types.PAGE_IN_PROGRESS_LOADS:
      return { ...state, pageInProgress: payload }

    case types.FETCH_INFO_LOADS:
      return {
        ...state,
        loadsQuantityInfo:
          state.loadsQuantityInfo === null ||
          state.loadsQuantityInfo.total <= payload.total
            ? {
                total: payload.total,
                normal: payload.normal,
                auction: payload.auction,
                lot: payload.lot,
              }
            : state.loadsQuantityInfo,
      }
    case types.FETCH_MARKET_LOADS:
      return {
        ...state,
        marketLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.marketLoads, ...payload.data],
        hasMoreNegotiation: payload.data.length >= loadPagination,
        hasMoreMarket: payload.data.length >= loadPagination,
        pageNegotiation: payload.page,
        lastUpdateMarket: new Date().getTime(),
      }
    case types.FETCH_REVIEW_LOADS:
      return {
        ...state,
        reviewLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.reviewLoads, ...payload.data],
        hasMoreReview: payload.data.length >= loadPagination,
        amountReview: [...state.reviewLoads, ...payload.data].length,
      }
    case types.FETCH_MY_LOADS:
      return {
        ...state,
        myLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.myLoads, ...payload.data],
        hasMoreMy: payload.data.length >= loadPagination,
        hasMoreHired: payload.data.length >= loadPagination,
        pageHired: payload.page,
        lastUpdateHired: new Date().getTime(),
      }
    case types.FETCH_LOCKED_LOADS:
      return {
        ...state,
        lockedLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.lockedLoads, ...payload.data],
        hasMoreLocked: payload.data.length >= loadPagination,
        hasMoreInTransit: payload.data.length >= loadPagination,
        pageInTransit: payload.page,
        lastUpdateTransit: new Date().getTime(),
      }
    case types.FETCH_CLOSED_LOADS:
      return {
        ...state,
        closedLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.closedLoads, ...payload.data],
        hasMoreClosed: payload.data.length >= loadPagination,
        hasMoreDelivered: payload.data.length >= loadPagination,
        pageDelivered: payload.page,
        lastUpdateDelivered: new Date().getTime(),
      }

    case types.FETCH_IN_PROGRESS_LOADS:
      return {
        ...state,
        inProgressLoads:
          payload.page === 1
            ? [...payload.data]
            : [...state.inProgressLoads, ...payload.data],
        hasMoreInProgress: payload.data.length >= loadPagination,
        pageInProgress: payload.page,
        lastUpdateInProgress: new Date().getTime(),
      }
    case types.FETCH_LOAD_RECEIPT: {
      return {
        ...state,
        allMappedLoads: {
          ...state.allMappedLoads,
          [payload.hashId.replace(/\W/g, '')]: {
            ...state.allMappedLoads[payload.hashId.replace(/\W/g, '')],
            localReceiptPath: payload.localReceiptPath,
          },
        },
      }
    }
    case types.COUNT_IS_LOADING_BY_STATUS:
      return {
        ...state,
      [payload.key]: payload.value,
      }

    case types.VIEW_COUNT_BY_STATUS:
      return {
        ...state,
        [payload.key]: payload.value,
      }
    case types.SET_AMOUNTS:
      return {
        ...state,
        [payload.key]: payload.value,
      }

    case types.HIDDEN_ALL_COUNTERS:
      return {
        ...state,
        amountNegotiation: 0,
        amountHired: 0,
        amountTransit: 0,
        amountDelivered: 0,
        amountInProgress: 0,

        viewAmountNegotiation: false,
        viewAmountHired: false,
        viewAmountTransit: false,
        viewAmountDelivered: false,
        viewAmountInProgress: false,

        loadingAmountNegotiation: false,
        loadingAmountHired: false,
        loadingAmountTransit: false,
        loadingAmountDelivered: false,
        loadingAmountInProgress: false,

      }
    case types.FETCH_LOAD_FOR_GROUP:
      return {
        ...state,
        loadsForGroup: payload,
      }
    default:
      return state
  }
}

export default Loads
